import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { URLConstants } from '@app/core/constants/URLConstants';
import { APIWithLoaderHelper } from '../helpers/apiWithLoaderHelper';
import { LocationParamsService } from './locationParamsService';

export interface ContributingOrganisation {
  id: number;
  name: string;
}

export type ContributingProjectSource = 'list_item' | 'project-name-other';

export interface ContributingProject {
  id: number | null;
  name: string;
  source: ContributingProjectSource;
  origin_organisation_id: number;
  origin_organisation_name: string;
}

@Injectable({
  providedIn: 'root',
})
export class SharedObservationFiltersService {
  constructor(private apiWithLoaderHelper: APIWithLoaderHelper, private locationParamsService: LocationParamsService) {}

  public getContributingOrganisations(): Observable<ContributingOrganisation[]> {
    return this.locationParamsService.getUrlWithParams(URLConstants.getContributingOrganisations).pipe(
      take(1),
      switchMap((urlWithParams) => this.apiWithLoaderHelper.get<ContributingOrganisation[]>(urlWithParams, {}, false))
    );
  }

  public getContributingProjects(originOrganisationIds: string[] = []): Observable<ContributingProject[]> {
    const params = originOrganisationIds.length
      ? { origin_organisation_ids: originOrganisationIds.join(',') }
      : undefined;

    return this.locationParamsService.getUrlWithParams(URLConstants.getContributingProjects, params).pipe(
      take(1),
      switchMap((urlWithParams) => this.apiWithLoaderHelper.get<ContributingProject[]>(urlWithParams, {}, false))
    );
  }
}
